import PublicationSuccess from './PublicationSuccess';
import AutoHelp from './AutoHelp'

const createAutoHelp = [
    {
        title: 'Введите текст объявления',
        progress: { title: 'Автопомощь', step: 2 },
        component: AutoHelp, valid: true, required: true,
    },
    {
        progress: { title: 'Спасибо', step: 3 },
        component: PublicationSuccess, valid: true, required: true,
    },
];

export default createAutoHelp;
